<template>
    <content-dashboard :hide="true">
        <v-form name="myform">
            <v-card class="mb-10">
                <v-card-title class="subtitle-1">Filtros</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="2" sm="12">
                            <v-text-field hide-details dense label="Código" v-model="filtro.codigo" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-text-field hide-details dense label="Observação" v-model="filtro.observacao" outlined></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" type="submit" @click.prevent="loadObservacoes(filtro)">Pesquisar</v-btn>
                    <v-btn color="primary" outlined class="ml-5" @click.prevent="resetFiltro">Limpar</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <v-col>
            <v-card>
                <v-card-title class="subtitle-1">Auditoria</v-card-title>
                <v-card-text>
                    <v-data-table :loading="loading" no-data-text="..." :headers="headers" :items="items" hide-default-footer :items-per-page="20">
                        <template v-slot:item.actions="{ item }">
                            <v-icon color="red" class="mr-2" @click="deleteObservacao(item)" title="Deletar">mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                   <v-pagination
                        color="primary"
                        v-model="paginate.current_page"
                        :length="paginate.last_page"
                        :total-visible="10"
                        @input="loadObservacoes($route.query, $event)"
                    >
                    </v-pagination>
                </v-card-actions>
            </v-card>
        </v-col>
    </content-dashboard>
</template>

<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";
import queryString from "querystring";

export default {
    name: "observacoes",
    
    components: {},
    
    data() {
        return {
            loading: false,
            filtro: {},
            items: [],
            paginate: {},
            headers: [
                { text: "Código", value: "codigo" },
                { text: "Observação", value: "observacao" },
                { text: "Ações", value: "actions" }
            ],
        }
    },

    created() {
        this.loadObservacoes(this.filtro, 1);
    },

    mounted() {},

    methods: {
        loadObservacoes(filtro, page) {
            this.loading = true;

            const filter = queryString.stringify(filtro);
            const url = `${urlApi}/tabelas-de-apoio/observacoes?${filter}&page=${page}`;

            this.$http.get(url).then(res => {
                const response = res.data.dados;

                this.items = response.observacoes.data;
                this.paginate = response.observacoes;
                
                this.loading = false;
            }).catch(showError);
        },

        deleteObservacao(item) {
            console.log(item);
        },

        resetFiltro() {
            this.filtro = {};
        },
    },
}
</script>